import { Component, Input } from '@angular/core';
import { ColumnSettings } from '../../common/models';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'date-viewer',
    templateUrl: './date-viewer.component.html',
    styleUrls: ['./date-viewer.component.scss'],
    imports:[DatePipe]
})
export class DateViewerComponent {
  @Input('record') record: any;
  @Input('column') column!: ColumnSettings;
}
